<!-- eslint-disable vue/no-deprecated-slot-attribute -->
<template>
  <ToolbarContainer>
    <template v-slot:toolbar>
      <nav>
        <div :class="$style.gridContainerOuter">
          <div :class="$style.gridItemOuter">
            <InputSearchFilter
              :class="$style.filterHeight"
              placeholder="Search"
              showValidationMessage
              value=""
            >
              <template v-slot:content>
                <SelectChipGroup
                  label="App Types:"
                  :options="filterOptions"
                  :value="[]"
                />
              </template>
            </InputSearchFilter>
          </div>
          <div :class="$style.gridItemInner">
            <MarkdownInline
              :class="$style.markdownItem"
              :mdTemplate="manageSoftCount"
            />
            <Button
              :class="$style.marginLeftSpacer"
              isDisabled
              text="Resend Command"
              textCase="capitalize"
              type="primary"
            />
          </div>
        </div>
      </nav>
    </template>
    <template
      v-if="!isTableEmpty"
      v-slot:body
    >
      <ItemListPagination
        :class="$style.tableContainer"
        columnGap=""
        :columns="columns"
        :currentPageNum="0"
        :isLoading="isListLoading"
        :itemComponent="$options.GoogleAppsStatusRow"
        :rowsPerPage="10"
        :selectAll="false"
        selectable
        sortBy="organizationName"
        sortDirection="ascending"
        :tableData="tableData"
        :totalCount="totalCount"
      />
    </template>
  </ToolbarContainer>
</template>

<script>
import {
  Button,
  InputSearchFilter,
  ItemListPagination,
  MarkdownInline,
  SelectChipGroup,
  ToolbarContainer,
  Types,
} from '@jumpcloud/ui-components';
import GoogleAppsStatusRow from 'client/SoftwareApps/GoogleAppsStatusRow.vue';

const { Column } = Types;

const appColumns = [
  Column({
    dataFieldName: 'status',
    label: 'Status',
    sortable: true,
    width: '',
    visible: true,
  }),
  Column({
    dataFieldName: 'deviceName',
    label: 'Device Name',
    sortable: true,
    width: '',
    visible: true,
  }),
  Column({
    dataFieldName: 'commandTimestamp',
    label: 'Command Timestamp',
    sortable: true,
    width: '',
    visible: true,
  }),
  Column({
    dataFieldName: 'details',
    label: 'Details',
    sortable: true,
    width: '',
    visible: true,
  }),
];

export default {
  name: 'GoogleAppsStatus',

  components: {
    Button,
    InputSearchFilter,
    ItemListPagination,
    MarkdownInline,
    SelectChipGroup,
    ToolbarContainer,
  },

  data() {
    return {
      columns: appColumns,
      filterOptions: [{ name: 'Public', value: 'public' }, { name: 'Private', value: 'private' }, { name: 'Web', value: 'web' }],
      isListLoading: false,
      isTableEmpty: false,
      manageSoftCount: '**101**  managed software packages',
      tableData: [{
        status: 'Command Sent', deviceName: 'Sergry-Machine-local', commandTimestamp: '2022-12-15T14:53:16.264Z', details: '',
      }, {
        status: 'Install Pending', deviceName: 'Sergry-Machine-local', commandTimestamp: '2022-12-15T14:53:16.264Z', details: '',
      }],
      totalCount: 100,
    };
  },

  GoogleAppsStatusRow,
};
</script>

<style module>
.gridContainerOuter {
  display: flex;
  margin-bottom: 0.75rem;
  margin-left: var(--jc-spacer-small);
  margin-top: 0.75rem;
}

.gridItemInner {
  display: flex;
  flex-wrap: wrap;
  margin-left: var(--jc-spacer);
  margin-right: var(--jc-spacer);
}

.gridItemOuter {
  flex: 1 1 auto;
  margin-left: var(--jc-spacer-x-small);
}

.markdownItem {
  align-items: center;
  display: flex;
  justify-content: center;
}

.tableContainer {
  padding: 0 var(--jc-spacer) 0.75rem var(--jc-spacer);
}

.tableContainer footer {
  bottom: 1% !important;
  position: absolute !important;
  width: 99% !important;
}

.filterHeight {
  margin-left: var(--jc-spacer-x-small);
}

.filterHeight > div > div:nth-child(2) > div > div:nth-child(2) {
  min-height: 6.375rem;
}

.marginLeftSpacer {
  margin-left: var(--jc-spacer);
}
</style>
